import classNames from 'classnames/bind';
import styles from './MyPayments.module.scss';
import TableClassicReport from '../base/TableClassicReport';
import { useEffect, useState } from 'react';
import { IMyPaymentsRecord, IPaginationReport } from '~/utils/interface/report';
import reportApi from '~/apis/report';
import { ColumnType } from '~/utils/types/common';
import dayjs from 'dayjs';

const cx = classNames.bind(styles);

const MyPayments = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IMyPaymentsRecord[]>([]);
  const [pagination, setPagination] = useState<IPaginationReport>({
    totalItems: 0,
    totalPage: 0,
    page: 1,
    limit: 10,
    skip: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await reportApi.getMyPayments({ page: pagination.page });
        setData(response.data?.data?.responses ?? []);
        setPagination(response.data?.data?.pagination ?? null);
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch my payments', error);
        setLoading(false);
      }
    };
    fetchData();
  }, [pagination.page]);


  const columns: Array<ColumnType> = [
    {
      id: "datePayment",
      labelHeader: "Date Payment",
      renderCell: (myPayments: IMyPaymentsRecord) => (
        <div
          className={cx("cell")}
        >
          <p className={cx("text-content")}>{dayjs(myPayments.datePayment).format("MM/DD/YYYY hh:mm A") || "-"}</p>
        </div>
      ),
    },
    {
      id: "paymentReference",
      labelHeader: "Reference",
      renderCell: (myPayments: IMyPaymentsRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{myPayments.paymentReference || "-"}</p>
        </div>
      ),
    },
    {
      id: "total",
      labelHeader: "Total",
      renderCell: (myPayments: IMyPaymentsRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{myPayments.total || 0}</p>
        </div>
      ),
    },
    {
      id: "invoice",
      labelHeader: "Invoice",
      renderCell: (myPayments: IMyPaymentsRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{myPayments.invoice.total ? `$${myPayments.invoice.total} ` : "-"}</p>
          <p className={cx("text-content")}>{myPayments.invoice.unicode ? `(#${myPayments.invoice.unicode})` : "-"}</p>
        </div>
      ),
    },
    {
      id: "method",
      labelHeader: "Method",
      renderCell: (myPayments: IMyPaymentsRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{myPayments.method || "-"}</p>
        </div>
      ),
    },
    {
      id: "relatedRecords",
      labelHeader: "Related Records",
      renderCell: (myPayments: IMyPaymentsRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{myPayments.relatedContact?.name || "-"} (Contact)</p>
          <p className={cx("text-content")}>{myPayments.job.uniqueCode ? `#${myPayments.job.uniqueCode} (Job)` : "-"}</p>
        </div>
      ),
    },
    {
      id: "createdBy",
      labelHeader: "Created By",
      renderCell: (myPayments: IMyPaymentsRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{myPayments.createdBy?.name || "-"}</p>
        </div>
      ),
    },
    {
      id: "dateUpdated",
      labelHeader: "Date Updated",
      renderCell: (myPayments: IMyPaymentsRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{dayjs(myPayments.dateUpdated).format("MM/DD/YYYY hh:mm A") || "-"}</p>
        </div>
      ),
    },
  ];


  return (
    <TableClassicReport<IMyPaymentsRecord>
      title="My Payments"
      columns={columns}
      data={data}
      page={pagination.page}
      totalPages={pagination.totalPage}
      totalItems={pagination.totalItems}
      itemsPerPage={pagination.limit}
      onPageChange={(page) => {
        setPagination({ ...pagination, page });
      }}
      isLoading={loading}
    />
  );
};

export default MyPayments;
